import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import {RegisterContainerComponent} from './containers/register/register-container.component';
import {RegistrationSuccessfulComponent} from './containers/registration-successful/registration-successful.component';
import {LoginContainerComponent} from './containers/login/login-container.component';

const authenticationRoutes: Routes = [
    { path: 'login', component: LoginContainerComponent },
    { path: 'register', component: RegisterContainerComponent },
    { path: 'registration-successful', component: RegistrationSuccessfulComponent}
  ];

@NgModule({
      imports: [
        RouterModule.forChild(authenticationRoutes)
      ],
      exports: [
          RouterModule
      ]
}) 
export class AuthenticationRouter {}
